import { NotificationOption, NotificationLevel, Notification, INotificationService } from './notification-service.interface';
import { IoCContainer, IWebCoreIoCContainer, WebCoreIoCKeys } from 'web-core-src';

export class NotificationService implements INotificationService {
    constructor() {
        this.ioc = IoCContainer.get(WebCoreIoCKeys.IWebCoreIoCContainer);
    }

    private NOTIFICATION_CLASS_NAME: string = 'simple-notification';
    private CONTAINER_CLASS_NAME: string = 'simple-notification-container';
    private CONTAINER_ID_NAME: string = 'notificationContainer';
    private CLOSE_NOTIFICATION_CLASS_NAME: string = 'close-notification';
    private CLOSE_NOTIFICATION_WRAPPER_CLASS_NAME: string = 'close-notification-wrapper';

    private idCounter: number = 0;
    options: NotificationOption;

    private ioc: IWebCoreIoCContainer;

    public createTimedSuccessTranslateMessage(message: string, seconds?: number, width?: number): void {
        return this.createTimedSuccessMessage(this.ioc.translation.getMessage(message), seconds, width);
    }

    public createTimedInfoTranslateMessage(message: string, time?: number, width?: number): void {
        return this.createTimedInfoMessage(this.ioc.translation.getMessage(message), time, width);
    }

    public createTimedWarningTranslateMessage(message: string, time?: number, width?: number): void {
        return this.createTimedWarningMessage(this.ioc.translation.getMessage(message), time, width);
    }

    public createTimedDangerTranslateMessage(message: string, time?: number, width?: number): void {
        return this.createTimedDangerMessage(this.ioc.translation.getMessage(message), time, width);
    }

    public createSuccessTranslateMessage(message: string, width?: number): void {
        return this.createSuccessMessage(this.ioc.translation.getMessage(message), width);
    }

    public createInfoTranslateMessage(message: string, width?: number): void {
        return this.createInfoMessage(this.ioc.translation.getMessage(message), width);
    }

    public createWarningTranslateMessage(message: string, width?: number): void {
        return this.createWarningMessage(this.ioc.translation.getMessage(message), width);
    }

    public createDangerTranslateMessage(message: string, width?: number): void {
        return this.createDangerMessage(this.ioc.translation.getMessage(message), width);
    }

    private createTimedSuccessMessage(message: string, seconds?: number, width?: number): void {
        this.notify(this.createTimedOption(message, NotificationLevel.success, width, seconds));
    }

    private createTimedInfoMessage(message: string, seconds?: number, width?: number): void {
        this.notify(this.createTimedOption(message, NotificationLevel.info, width, seconds));
    }

    private createTimedWarningMessage(message: string, seconds?: number, width?: number): void {
        this.notify(this.createTimedOption(message, NotificationLevel.warning, width, seconds));
    }

    private createTimedDangerMessage(message: string, seconds?: number, width?: number): void {
        this.notify(this.createTimedOption(message, NotificationLevel.danger, width, seconds));
    }

    private createSuccessMessage(message: string, width?: number): void {
        this.notify(this.createOption(message, NotificationLevel.success, width));
    }

    private createInfoMessage(message: string, width?: number): void {
        this.notify(this.createOption(message, NotificationLevel.info, width));
    }

    private createWarningMessage(message: string, width?: number): void {
        this.notify(this.createOption(message, NotificationLevel.warning, width));
    }

    private createDangerMessage(message: string, width?: number): void {
        this.notify(this.createOption(message, NotificationLevel.danger, width));
    }

    private createTimedOption(message: string, level: NotificationLevel, width?: number, seconds?: number): NotificationOption {
        let option: NotificationOption = this.createOption(message, level, width);
        option.autoClose = true;
        if (seconds) {
            option.time = seconds * 1000;
        }
        return option;
    }

    public createOption(message: string, level: NotificationLevel, width?: number): NotificationOption {
        let option: NotificationOption = new NotificationOption();
        option.message = message;
        option.level = level;
        if (width) {
            option.width = width;
        }
        return option;
    }

    public notify(options: NotificationOption): void {
        this.options = options;

        //TODO LATER: width does not work: FIX IT!
        let newNotification: Notification = new Notification();
        newNotification.id = 'notification' + this.idCounter++;
        newNotification.message = this.options.message;
        newNotification.level = this.options.level;

        if (!document.getElementById(this.CONTAINER_ID_NAME)) {
            this.createContainer();
        }
        this.showNotification(newNotification);
    }

    private createContainer(): void {
        let divContainer: HTMLDivElement = document.createElement('div');
        divContainer.id = this.CONTAINER_ID_NAME;
        divContainer.className = this.CONTAINER_CLASS_NAME;
        document.body.appendChild(divContainer);
    }

    private showNotification(notification: Notification): void {
        let notificationDiv: HTMLDivElement = document.createElement('div');
        notificationDiv.className = this.NOTIFICATION_CLASS_NAME + ' ' + notification.level;
        notificationDiv.id = notification.id;
        notificationDiv.innerHTML = notification.message + '<div class="' + this.CLOSE_NOTIFICATION_WRAPPER_CLASS_NAME + '"><i class="fas fa-close ' + this.CLOSE_NOTIFICATION_CLASS_NAME + '"></i></div>';
        // notificationDiv.style.width = this.options.width + 10 + 'px';
        notificationDiv.style.width = '300px';

        let closeButton: HTMLDivElement = notificationDiv.querySelector('.' + this.CLOSE_NOTIFICATION_WRAPPER_CLASS_NAME);
        closeButton.addEventListener('click', (e: Event): boolean => {
            this.close(notificationDiv);
            return false;
        });

        let notificationWrapperDiv: HTMLDivElement = document.createElement('div');
        notificationWrapperDiv.className = 'simple-notification-wrapper';
        notificationWrapperDiv.appendChild(notificationDiv);

        let notificationContainer: HTMLElement = document.getElementById(this.CONTAINER_ID_NAME);
        notificationContainer.insertBefore(notificationWrapperDiv, notificationContainer.firstChild);

        if (this.options.autoClose) {
            setTimeout((): void => {
                this.close(notificationDiv);
            }, this.options.time);
        }
    }

    public closeAllMessages(): void {
        let notifications: HTMLCollectionOf<Element> = document.getElementsByClassName(this.NOTIFICATION_CLASS_NAME);
        for (let notificationDiv of Array.from(notifications)) {
            this.close(notificationDiv as HTMLDivElement);
        }
    }

    private close(notificationDivToRemove: HTMLDivElement): void {
        notificationDivToRemove.className = notificationDivToRemove.className + ' fade-out';
        notificationDivToRemove.addEventListener(
            'transitionend',
            (): void => {
                if (document.getElementById(this.CONTAINER_ID_NAME).contains(notificationDivToRemove.parentElement)) {
                    document.getElementById(this.CONTAINER_ID_NAME).removeChild(notificationDivToRemove.parentElement);
                }
            },
            false
        );
    }
}
